import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';

// Resets the scroll position to the top when navigating.
//
// By default, scroll position will be reset whenever `location.pathname` changes.
// It's possible to opt out of the default scroll reset by setting the
// `shouldResetScroll` flag to `false` in location state.
// Conversely, you can manually trigger a scroll reset when it would
// not normally happen by setting `shouldResetScroll` to `true`.
//
// https://reacttraining.com/react-router/web/guides/scroll-restoration

const resetScrollPosition = () => window.scrollTo(0, 0);

function ScrollToTop() {
	const {pathname, state} = useLocation();
	const {shouldResetScroll} = state || {};

	// Scroll to top when location.path changes
	// `shouldResetScroll` is intentionally not listed as a dependency
	// as we don't want to trigger the hook if it changes from
	// `false` to `undefined` (e.g. when a modal is opened using a
	// query parameter).
	useLayoutEffect(() => {
		if (shouldResetScroll === undefined) {
			resetScrollPosition();
		}
	}, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

	// Scroll to top when `state.shouldResetScroll` is set to true
	useLayoutEffect(() => {
		if (shouldResetScroll === true) {
			resetScrollPosition();
		}
	}, [shouldResetScroll]);

	return null;
}

export default ScrollToTop;
